import React from 'react'
import { AiOutlineEye } from 'react-icons/ai';

function PatientMonthlyTable({data}) {
  return (
    <div>
                <div>
                    <div className={`min-w-full ${data ? 'w-max' : 'flex-1'} rounded-lg flex justify-center`}>
                        <table className={`w-full overflow-scroll relative`}>
                            <thead className='sticky top-0'>
                                <tr>
                                    <th>Patient Name & Id</th>
                                    <th>Gender</th>
                                    <th>Program</th>
                                    <th>Dob</th>
                                    <th>Hospitals/Medical Practice</th>
                                    <th>Provider</th>
                                    <th>Care Team</th>
                                    <th>Action</th>
                                </tr>
                                <tr className="bg-[#DEF3F2]">
                                    <td className='py-0.5' colSpan={8}></td>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                {
                                    data?.map((item, idx) => (
                                        <>
                                            <tr key={idx}>
                                                <td>{`${item?.firstName}${item?.lastName ? " " + item?.lastName : ""}`}
                                                    <br />
                                                    {item.patientId}
                                                </td>
                                                <td>{item.gender === 'M'? 'Male':item.gender === 'F'?'Female':'-'}</td>
                                                <td>{item.rpmApplicable === 'Y'? 'RPM':'-'}</td>
                                                <td>{item.dob}</td>
                                                <td>{item.hospitalName}</td>
                                                <td>{item.providerName}</td>
                                                <td>-</td>
                                                <td>
                                                    <button className="flex items-center bg-[#EEFEFF] gap-1 px-3 py-1 border border-sky-400 text-sky-600 rounded-md text-xs">
                                                        <AiOutlineEye className="w-4 h-4" />
                                                        View
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr className="bg-[#DEF3F2]">
                                                <td className='py-0.5' colSpan={8}></td>
                                            </tr>
                                        </>
    
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
  )
}

export default PatientMonthlyTable;